import { appstr } from "../utils/appstr";
import { QAlert } from "./QAlert";
import { QRFC } from "./QRFC";
import { Globals } from "./Globals";

export class QBuildTableRFC extends QRFC {
  constructor() {
    super();
  }

  InitUpdateTables(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  GetCallName() {
    return "qmongorfc";
  }

  SetParams(orgName, user, mode, data, chartID = null) {
    this.AddParameter("data", data);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
    if (chartID) {
      this.AddParameter("chartID", chartID);
    }
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var wsMgr = Globals._wsMgr;
    var success = r["success"];
    if (wsMgr.fWaiting) {
      wsMgr.ClearAppLoadingAnimation();
      wsMgr.fWaiting = null;
    }
    if (!success) {
      var alert = new QAlert();
      alert.InitAlert(
        appstr("Unable to Save Changes"),
        appstr("SystemError") +
          "\n" +
          appstr("Error") +
          ": " +
          "'" +
          r["message"] +
          "'" +
          ", Code: " +
          r["code"],
        null,
        wsMgr
      );
      wsMgr.PrepRenderWS();
      wsMgr.RenderWS();
      return;
    }
    if (r["tables"]) {
      wsMgr.fOrgInfo.SetAppendTableList(r["tables"]);
    }
    callBackObj.HandleResponse(response);
    wsMgr.PrepRenderWS();
    wsMgr.RenderWS();
  }
}
